// extracted by mini-css-extract-plugin
export default {"body":"MobileFooter_body__a5k5T","tabs":"MobileFooter_tabs__LLh03","active":"MobileFooter_active__pMOAP"};